// src/pages/About.js
import React from 'react';

const About = () => (
  <div className="page">
    <h1>من نحن</h1>
    <p>هذه صفحة تعريفية.</p>
  </div>
);

export default About;
